import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Card,
    Button,
    notification,
    Form,
    Select,
    Input,
} from "antd";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { baseUrl } from "../../config";

const { Item } = Form;

function SettingForm() {
    const navigate = useNavigate();
    const [form] = Form.useForm();

    useEffect(() => {
        fetchDetails();
    }, []);

    const fetchDetails = async () => {
        try {
            const response = await axios.get(`${baseUrl}/api/get-site-reviews`);
            if (response.status === 200) {
                form.setFieldsValue(response?.data?.result?.data); // Populate form fields with fetched data
            } else {
                notification.info({
                    message: 'Info',
                    description: response.data.message,
                    placement: 'topRight'
                });
            }
        } catch (error) {
            console.error("API error:", error);
            notification.info({
                message: 'Info',
                description: error.response?.data?.message,
                placement: 'topRight'
            });
        }
    };

    const onFinish = async (values) => {
        try {

            const response = await axios.patch(`${baseUrl}/api/config?type=key_metrics`, values, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
                },
            });
            if (response.status === 200) {
                notification.success({
                    message: 'Success',
                    description: 'Setting updated successfully!',
                    placement: 'topRight'
                });
                // navigate('/page-management');
            } else {
                notification.info({
                    message: 'Info',
                    description: response.data.message,
                    placement: 'topRight'
                });
            }
        } catch (error) {
            console.error("API error:", error);
            notification.info({
                message: 'Info',
                description: error.response?.data?.message,
                placement: 'topRight'
            });
        }
    };

    return (
        <div className="tabled">
            <Row gutter={[24, 0]}>
                <Col xs="24" xl={24}>
                    <Card
                        bordered={false}
                        className="criclebox tablespace mb-24"
                        title="Settings"
                    >
                        <Form style={{ "padding": "20px" }} form={form} onFinish={onFinish} layout="vertical">
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12} lg={12}>
                                    <Item
                                        label="Facebook Link"
                                        name="facebookLink"
                                        rules={[{ required: true, message: 'Please enter facebook link.' }]}
                                    >
                                        <Input placeholder="Please enter facebook link" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={12}>
                                    <Item
                                        label="Instagram Link"
                                        name="instagramLink"
                                        rules={[{ required: true, message: 'Please enter instagram link.' }]}
                                    >
                                        <Input placeholder="Please enter instagram link" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={12}>
                                    <Item
                                        label="Twitter Link"
                                        name="twitterLink"
                                        rules={[{ required: true, message: 'Please enter twitter link.' }]}
                                    >
                                        <Input placeholder="Please enter twitter link" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={12}>
                                    <Item
                                        label="YouTube Link"
                                        name="youtubeLink"
                                        rules={[{ required: true, message: 'Please enter youtube link.' }]}
                                    >
                                        <Input placeholder="Please enter youtube link" />
                                    </Item>
                                </Col>


                                <Col xs={24} sm={12} lg={12}>
                                    <Item
                                        label="Active Content Creators"
                                        name="contentCreators"
                                        rules={[{ required: true, message: 'Please enter content creators.' }]}
                                    >
                                        <Input placeholder="Please enter content creators" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={12}>
                                    <Item
                                        label="Earning Paid"
                                        name="earningsPaid"
                                        rules={[{ required: true, message: 'Please enter earning paid.' }]}
                                    >
                                        <Input placeholder="Please enter earning paid" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={12}>
                                    <Item
                                        label="Ideas Shared"
                                        name="ideasShared"
                                        rules={[{ required: true, message: 'Please enter ideas shared.' }]}
                                    >
                                        <Input placeholder="Please enter ideas shared" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={12}>
                                    <Item
                                        label="Monthly Visitors"
                                        name="monthlyVisitors"
                                        rules={[{ required: true, message: 'Please enter monthly visitors.' }]}
                                    >
                                        <Input placeholder="Please enter monthly visitors" />
                                    </Item>
                                </Col>

                            </Row>
                            <Row>
                                <Col xs={24} sm={12} lg={8}>
                                    <Item>
                                        <Button type="primary" htmlType="submit">
                                            Update
                                        </Button>
                                    </Item>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}

export default SettingForm;
